import {Callback} from './Callback';

export default Callback;
